import api from '../../services/api'

export const addToCart = ({commit}, survey) => {
  commit('ADD_TO_CART', survey)
}

export const removeFromCart = ({commit}, fid) => {
  commit('REMOVE_FROM_CART', fid)
}

export const setSurveyPreview = ({commit}, survey) => {
  commit('SET_SURVEY_PREVIEW', survey)
}

export const setSurveys = ({commit}, surveys) => {
  commit('SET_SURVEYS', surveys)
}

export const setTemplateHashes = ({commit}, templateHashes) => {
  commit('SET_TEMPLATEHASHES', templateHashes)
} 

export const sendPayment = async ({commit}, {currency, description, price, method, templateNames, token, database}) => {
  let response = await api.surveyStoreService.sendPayment({currency: currency, description: description, price: price, method: method, templateNames: templateNames, token: token, database: database})
  return response.data
}

export const listPaymentMethods = async({commmit}, {token, database}) => {
  let response = await api.surveyStoreService.listPaymentMethods({token: token, database: database})
  return response.data
}

export const getPaymentInfo = async({commit}, {token, database, paymentId}) =>{
  let response = await api.surveyStoreService.getPaymentInfo({token: token, database: database, paymentId: paymentId})
  return response.data
}

export const updatePaymentInfo = async({commit}, {token, database, paymentId, processed}) =>{
  let response = await api.surveyStoreService.updatePaymentInfo({token: token, database: database, paymentId: paymentId, processed: processed})
  return response.data
}

export const calculateCronbachScore = async({commit}, {token, database, itemscores}) =>{
  let response = await api.surveyStoreService.calculateCronbachScore({token: token, database: database, itemscores: itemscores})
  return response.data
}